// Stepping the public board's rotation.
//
// Its own module so the wrapping can be tested. It looks like arithmetic
// that cannot be wrong, and it can: JavaScript's `%` keeps the sign of the
// dividend, so `(0 - 1) % 5` is `-1`, not `4`. A "previous panel" that
// produced `-1` would index past the start of the array and render nothing
// at all — on the wall display, which is the one surface nobody is watching
// when it breaks.

/**
 * The panel to show after moving `delta` slots from `current`, wrapping.
 *
 * Works for negative deltas, which is the case that needs the second
 * modulo: `((i + delta) % n + n) % n`.
 *
 * An empty list yields 0 rather than NaN, so a board with no panels
 * configured renders its empty state instead of crashing.
 */
export function stepPanel(current: number, delta: number, count: number): number {
  if (count <= 0) return 0;
  return (((current + delta) % count) + count) % count;
}

/**
 * How long a panel should be shown, given the configured rotation and a
 * manual move.
 *
 * A manual move restarts the clock: clicking to the panel you want should
 * give you a FULL turn to read it, not whatever fraction of the current
 * interval happened to remain. Kept as a named function because the reason
 * is easy to lose — without it the behaviour is "sometimes it changes
 * immediately", which reads as a bug rather than as a decision.
 */
export function isManualRestart(_movedByHand: boolean): boolean {
  return _movedByHand;
}
